


























































































































import {
  Component,
  Vue,
  Prop, Watch,
} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import SubscriptionsService from '@/services/subscriptions.service';
import {Organisation, SubscriptionOrder, SubscriptionProduct} from '@/types';
import moment from 'moment';

@Component({
  components: {},
})
export default class AddSubscriptionOrderForm extends Vue {
  @Getter private login: any;
  @Getter private organisations: any;
  @Prop({default: null}) private subscriptionOrder!: SubscriptionOrder | null;
  @Prop({default: true}) private showOrgSelect!: boolean;
  // @Prop({default: true}) private showSave!: boolean;
  @Prop({default: false}) private fromStock!: boolean;
  @Prop() private saveSubscriptionOrderExternal!: boolean;
  @Prop({default: () => []}) private subscriptionProducts!: SubscriptionProduct[];
  @Prop({default: -1}) private selectedOrg!: number;
  @Prop({default: false}) private editing!: boolean;

  private defaultOrder: SubscriptionOrder = { order_number: '' } as SubscriptionOrder;
  private order: SubscriptionOrder = this.defaultOrder;

  private orgList: any[] = [];
  private isSaving: boolean = false;
  private activateByMenu: boolean = false;
  private activateBy: string | null = null;
  private validForm: boolean = true;

  public async save() {
    this.isSaving = true;
    try {
      // Sort the number columns
      // this.plan.term_length = Number(this.plan.term_length);
      this.order.subscription_product_id = this.order.subscription_product ? this.order.subscription_product.id : undefined;
      this.order.commercial_account_id = this.organisations.organisations.find((o: Organisation) => o.id === this.order.organisation_id).billing_account_id;
      this.order.total_subscriptions = Number(this.order.total_subscriptions);
      this.order.order_number = this.order.order_number ? this.order.order_number : `DAIZY_${moment().format('YYYYMMDD_HHmmss')}`;
      this.order.activate_by = new Date(this.activateBy!);
      const order = this.order.id
          ? await SubscriptionsService.updateSubscriptionOrder(this.order)
          : await SubscriptionsService.createSubscriptionOrder(this.order);

      this.fromStock ? this.$emit('savedSubscriptionOrder', order) : this.$emit('savedSubscriptionOrder');
    } catch (e) {
      this.$emit('incompleteSubscriptionCreation');
      throw e;
    } finally {
      this.isSaving = false;
    }
  }

  @Watch('order', {deep: true})
  private onOrderChange() {
    this.$emit('change:order', this.order);
    this.$emit('saving', this.isSaving);
  }

  @Watch('validForm', { immediate: true })
  private onValidFormChange() {
    this.$emit('form:valid', this.validForm);
  }

  private mounted() {
    if (this.subscriptionOrder) {
      Vue.set(this, 'order', this.subscriptionOrder);
      this.order.subscription_product = this.subscriptionOrder.subscription_product ? this.subscriptionOrder.subscription_product : undefined;
      this.order.organisation_id = this.subscriptionOrder.organisation ? this.subscriptionOrder.organisation.id : undefined;
      this.activateBy = moment(this.subscriptionOrder.activate_by).format('YYYY-MM-DD');
    } else {
      this.order = this.defaultOrder;
    }
    this.makeOrgList();
  }

  private makeOrgList() {
    this.orgList = this.organisations.organisations.map((org: any) => {
      return {
        text: org.name,
        value: org.id,
        billing_account: org.billing_account_id ? org.billing_account.name : 'N/A',
        billing_account_id: org.billing_account_id,
      };
    });
  }

  @Watch('saveSubscriptionOrderExternal')
  private async saveExternal() {
    if (this.saveSubscriptionOrderExternal) {
      await this.save();
    }
  }

  private setActivateBy() {
    if (this.order.subscription_product) {
      this.activateBy = moment().add(this.order.subscription_product.activation_period, 'days').format('YYYY-MM-DD');
    }
  }

  private filterProducts(item: SubscriptionProduct, queryText: string, itemText: string) {
    return (
        item.product_code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    );
  }

  private get activateByLabel() {
    if (this.$options.filters) {
      return this.$options.filters.formatShortDate(this.activateBy);
    } else {
      return '';
    }
  }

  private get tomorrow() {
    return moment().add(1, 'd').format('YYYY-MM-DD');
  }

  private get disableNumberOfSubs() {
    if (this.subscriptionOrder) { // editing
      const product = this.subscriptionProducts.find((p) => this.order.subscription_product && p.id === this.order.subscription_product.id);
      if (product) {
        return product.requires_sim;
      }
    } else if (this.fromStock) { // adding from sim stock
      return true;
    } else { // adding from subscription plans
      // if (this.planTypes.length && this.order.plan_type_code) {
      //   const type = this.planTypes.find((t: any) => t.text === this.order.plan_type_code);
      //   return type.has_sims;
      // } else {
      //   return true;
      // }
    }
  }
}
